<template>
  <button
    class="button button-h40 relative mx-auto w-full transition-colors duration-200 hover:bg-Black06"
    :class="isWideSize ? 'md:w-80' : 'md:w-60'"
    v-on="$listeners"
  >
    {{ $t('Common.button.more') }}
    <AppLoader v-if="isLoading" class="bottom-9px absolute right-0 mr-2 h-5 w-5" />
    <AppIcon v-else icon="arrow-down-black" class="bottom-9px absolute right-0 mr-2 h-5 w-5" />
  </button>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import AppIcon from '~/components/partials/App/AppIcon.vue';
import AppLoader from '~/components/partials/App/AppLoader.vue';

export default defineComponent({
  components: {
    AppIcon,
    AppLoader,
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    isWideSize: {
      type: Boolean,
      default: false,
    },
  },
});
</script>

<style scoped>
.bottom-9px {
  bottom: 9px;
}
</style>
